// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner[data-v-44620b0f]{align-items:center;background-color:#002144;display:flex;height:2rem;justify-content:center;position:relative;width:100%}.banner.homepage[data-v-44620b0f]{background-color:#212528}@media(prefers-color-scheme:dark){.banner.homepage[data-v-44620b0f]{background-color:#002144}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
